import React from 'react';

const Loader = ({ size = 'md', text = '' }) => {
    const sizeClasses = {
        sm: 'w-4 h-4 border-2',
        md: 'w-8 h-8 border-2',
        lg: 'w-12 h-12 border-[3px]'
    };

    const textSizeClasses = {
        sm: 'text-xs',
        md: 'text-sm',
        lg: 'text-base'
    };

    return (
        <div className="flex flex-col items-center justify-center gap-1">
            <div className={`${sizeClasses[size]} border-custom-light-blue/30 border-t-custom-light-blue rounded-full animate-spin`}></div>
            {text && (
                <p className={`${textSizeClasses[size]} text-white/70 font-medium`}>
                    {text}
                </p>
            )}
        </div>
    );
};

export default Loader;
